// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2ptAy","resendInfoText":"OnGoingPaymentBox_resendInfoText__1b_e7"};